<!-- 模板配置 -->
<template>
  <div class="settings-template-config">
    <templateConfig
      :description="
        isCluster
          ? '在集群层面，对整期推送、主题推送、专题推送、单篇推送、通知推送以及统一的邮件推送模板进行配置管理。期刊各自的邮件推送模板和推送核心内容由各自管理。'
          : '对整期推送、专题推送、单篇推送、通知推送以及统一的邮件推送模板进行配置管理。'
      "
      @toDetail="toDetail"
      :template-options="emailTypes"
    ></templateConfig>
  </div>
</template>

<script>
import templateConfig from '@/components/templateConfig/templateConfig.vue'
import templateConfigMixin from '@/mixins/templateConfig'
export default {
  name: 'SettingsTemplateConfig',
  components: {
    templateConfig
  },
  mixins: [templateConfigMixin],
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    toDetail(row) {
      const columnId = this.$route.query.columnId || '10-3' // 新-主动推送 -> 基础设置
      this.$router.push({
        path: '/newActivePushSettings/settingsTemplateConfigDetail',
        query: {
          templateId: row.id,
          type: row.type,
          columnId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
